import { render, staticRenderFns } from "./Modality.vue?vue&type=template&id=ca5b5aa8&"
import script from "./Modality.vue?vue&type=script&lang=js&"
export * from "./Modality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports